import store from '@/store'
import { MarkerClusterer } from '@googlemaps/markerclusterer'

export default {
  getLabelAnchor(showEntityType, icon) {
    // Por diseño de icono es necesario saber si el rumbo es norte para incrementar la
    // posicion del label sobre el eje Y
    if (showEntityType && icon.includes('N.png')) {
      return new google.maps.Point(45, 55)
    } else if (showEntityType) {
      return new google.maps.Point(45, 46)
    } else {
      return new google.maps.Point(45, 40)
    }
  },
  adjustMapBounds() {
    const follow = store.getters['uiState/follow']
    const stateThings = store.getters['mapState/getThingsToFollow']
    const map = store.getters.map
    if (follow && stateThings.length > 0) {
      this.bounds = new google.maps.LatLngBounds()
      stateThings.map(thing => {
        const latLng = new google.maps.LatLng(
          thing.position.lat,
          thing.position.lng
        )
        this.bounds.extend(latLng)
      })
      map.fitBounds(this.bounds)
      if (map.zoom > 14.5) {
        map.setZoom(14.5)
      }
    }
  },
  createMarkerCluster({ map, markers }) {
    const images = require.context('@/assets/', true, /\.png$/)

    const icon = {
      url: images(`./rec.png`),
      scaledSize: new google.maps.Size(53, 53),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(25, 25)
    }

    const renderer = {
      render: ({ count, position, markers }) => {
        const marker = new google.maps.Marker({
          label: { text: count.toString(), color: 'white', fontSize: '12px' },
          position,
          icon: icon,
          title: 'Ampliar para ver las entidades de esta zona',
          // adjust zIndex to be above other markers
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
          opacity: 0.75,
          optimized: true
        })

        let tooltipMarker

        marker.addListener('mouseover', () => {
          let col = ''
          let content = ''
          markers.forEach((marker, idx) => {
            content += `<span class="badge badge-pill secondary--text">${marker.labelContent}</span><br>`
            if (idx === markers.length - 1 || idx % 15 === 14) {
              if (content !== '')
                col += `<div class='col pa-0 ma-0'>${content}</div>`
              content = ''
            }
          })

          const tooltipContent = `<div class='container pa-0'><div class="row pa-0 ma-0">${col}</div></div>`
          tooltipMarker = new google.maps.InfoWindow({
            content: tooltipContent,
            headerDisabled: true
          })

          tooltipMarker.open(map, marker)
        })

        marker.addListener('mouseout', () => {
          tooltipMarker.close()
        })

        return marker
      }
    }

    return new MarkerClusterer({
      map: map,
      markers: markers,
      renderer: renderer
    })
  }
}
